import { render, staticRenderFns } from "./DeleteAdmin.vue?vue&type=template&id=044b7a8c&scoped=true&"
import script from "./DeleteAdmin.vue?vue&type=script&lang=ts&"
export * from "./DeleteAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b7a8c",
  null
  
)

export default component.exports